<template>
  <div
    :style="`background-color: rgb(${bgColor}, ${bgColor}, 255)`"
    class="ml-1 list"
  >
    <div
      v-for="(field, fieldIndex) in fields"
      :key="fieldIndex"
      class="list-item"
    >
      <div class="line">
        <div
          v-if="field.type === 'array'"
          class="form-group py-3 mb-0 pl-0 d-block"
        >
          <i
            :class="{'fa-caret-right': !view['a-' + fieldIndex], 'fa-caret-down': view['a-' + fieldIndex]}"
            class="fa mr-1"
            @click="toggleView('a-' + fieldIndex)"
          />
          <div class="input-group d-inline-block w-auto">
            <label
              class="control-label"
              @click="toggleView('a-' + fieldIndex)"
            >
              {{ camelCaseToSentenceCase(field.name) }}
              ({{ component[field.name] ? component[field.name].length : 0 }})
              <span
                v-if="field.description"
                class="text-charcoal text-transform-initial"
              >
                - <span v-html="field.description" />
              </span>
            </label>
            <i
              title="Add"
              class="fa fa-plus text-primary ml-2"
              @click="addElementToArray(component, field)"
            />
          </div>
          <div class="list">
            <div
              v-for="(item, index) in component[field.name]"
              v-show="view['a-' + fieldIndex]"
              :key="index"
              class="ml-3 py-2 list-item"
            >
              <div class="line">
                <i
                  :class="{'fa-caret-right': !view['a-' + fieldIndex + '-' + index], 'fa-caret-down': view['a-' + fieldIndex + '-' + index]}"
                  class="fa mr-1"
                  @click="toggleView('a-' + fieldIndex + '-' + index)"
                />
                <div class="input-group d-inline-block w-auto">
                  <label
                    class="control-label"
                    @click="toggleView('a-' + fieldIndex + '-' + index)"
                  >
                    {{ camelCaseToSentenceCase(field.name) }}
                    <span class="text-charcoal text-transform-initial">
                      {{ (item && item.name) || (index + 1) }}
                    </span>
                  </label>
                  <i
                    title="Remove"
                    class="fa fa-trash text-danger ml-2"
                    @click="removeElementFromArray(component[field.name], index)"
                  />
                </div>
                <div v-show="view['a-' + fieldIndex + '-' + index]">
                  <input
                    v-if="field.name === 'components' && typeof item === 'string'"
                    v-model="component[field.name][index]"
                    class="d-inline"
                  >
                  <page-component
                    v-else-if="field.name === 'components' || field.name === 'fields'"
                    :component="item"
                    :type="field.name"
                    :pre-defined-components="preDefinedComponents"
                    :bg-color="bgColor - 5"
                    class="ml-3"
                    @remove-component="removeElementFromArray(component[field.name], index)"
                    @set-component="setComponent($event, component[field.name], index)"
                  />
                  <textarea
                    v-else-if="field.data.type === 'string'"
                    v-model="component[field.name][index]"
                    :placeholder="field.default"
                    class="d-inline resize"
                  />
                  <input
                    v-else-if="field.data.type === 'number'"
                    v-model="component[field.name][index]"
                    type="number"
                    class="d-inline"
                  >
                  <fields-new
                    v-else
                    :fields="field.data"
                    :component="item"
                    :pre-defined-components="preDefinedComponents"
                    :bg-color="bgColor - 5"
                    class="mb-3 d-inline-block w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="field.type === 'object' && !field.data"
          class="form-group py-3 mb-0 pl-0 d-block"
        >
          <i
            :class="{'fa-caret-right': !view['o-' + fieldIndex], 'fa-caret-down': view['o-' + fieldIndex]}"
            class="fa mr-1"
            @click="toggleView('o-' + fieldIndex)"
          />
          <div class="input-group d-inline-block w-auto">
            <label
              class="control-label"
              @click="toggleView('o-' + fieldIndex)"
            >
              {{ camelCaseToSentenceCase(field.name) }}
              <span
                v-if="field.description"
                class="text-charcoal text-transform-initial"
              >
                - <span v-html="field.description" />
              </span>
            </label>
            <i
              title="Add"
              class="fa fa-plus text-primary ml-2"
              @click="addPropToObject(component, field)"
            />
          </div>
          <div class="list">
            <div
              v-for="(value, key) in component[field.name]"
              v-show="view['o-' + fieldIndex]"
              :key="key"
              class="ml-3 py-2 list-item"
            >
              <input
                :value="key"
                type="text"
                class="w-25 d-inline"
                @input="editKey(component[field.name], key, $event.target.value)"
              >:
              <input
                v-model="component[field.name][key]"
                type="text"
                class="w-25 d-inline"
              >
              <i
                title="Remove"
                class="fa fa-trash text-danger ml-2"
                @click="removePropFromObject(component[field.name], key)"
              />
            </div>
          </div>
        </div>
        <div
          v-else
          class="form-group mb-0 pl-0"
        >
          <i
            v-if="field.type === 'object' && field.data"
            :class="{'fa-caret-right': !view['o-' + fieldIndex], 'fa-caret-down': view['o-' + fieldIndex]}"
            class="fa mr-1"
            @click="toggleView('o-' + fieldIndex)"
          />
          <div class="input-group d-inline-block w-100">
            <label
              class="control-label"
              @click="toggleView('o-' + fieldIndex)"
            >
              {{ camelCaseToSentenceCase(field.name) }}
              <span
                v-if="field.description"
                class="text-charcoal text-transform-initial"
              >
                - <span v-html="field.description" />
              </span>
              <i
                title="Clear value"
                class="fa fa-ban text-danger ml-1"
                @click="delete component[field.name]"
              />
              <input
                v-if="field.type === 'boolean'"
                v-model="component[field.name]"
                class="w-auto"
                type="checkbox"
              >
            </label>
            <div v-if="field.type === 'string'">
              <field-rich-text
                v-if="field.renderer === 'richText'"
                v-model="component[field.name]"
                @input="component[field.name] = $event"
              />
              <input
                v-else
                v-model="component[field.name]"
                :placeholder="field.default"
                type="text"
              >
            </div>
            <div v-if="field.type === 'number'">
              <input
                v-model="component[field.name]"
                :placeholder="field.default"
                type="number"
              >
            </div>
            <fields-new
              v-if="typeof component[field.name] === 'object' && field.type === 'object' && field.data"
              v-show="view['o-' + fieldIndex]"
              :fields="field.data"
              :component="component[field.name]"
              :pre-defined-components="preDefinedComponents"
              :bg-color="bgColor - 5"
            />
            <field-json
              v-if="field.type === 'json'"
              :value="objectAsString(component[field.name])"
              @input="value => setObjectFromString(field.name, value)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { js_beautify as jsBeautify } from 'js-beautify'
import FieldRichText from '@/components/form/FieldRichText'
import FieldJson from '@/components/form/FieldJson'
import { debounce } from 'lodash'

export default {
  name: 'FieldsNew',
  components: {
    FieldRichText,
    FieldJson,
    PageComponent: () => import('./PageComponent')
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    preDefinedComponents: {
      type: Array,
      required: true
    },
    bgColor: {
      type: Number,
      default: 255
    }
  },
  data () {
    return {
      view: {}
    }
  },
  watch: {
    fields () {
      this.setDefaultValues()
    }
  },
  created () {
    this.setDefaultValues()
  },
  methods: {
    addElementToArray (component, field) {
      if (typeof component[field.name] === 'undefined') {
        component[field.name] = field.default || []
      }

      let element = ''
      if (field.name === 'fields') {
        element = {
          componentType: 'Text'
        }
      } else if (!field.data || !['string', 'number'].includes(field.data.type)) {
        element = {}
      }
      component[field.name].push(element)
      this.$forceUpdate()
    },
    removeElementFromArray (el, index) {
      el.splice(index, 1)
      this.$forceUpdate()
    },
    camelCaseToSentenceCase (label) {
      return label.replace(/[A-Z]/g, c => ' ' + c)
    },
    setDefaultValues () {
      for (let field of this.fields) {
        if (typeof this.component[field.name] === 'undefined') {
          if (field.type === 'object') {
            this.component[field.name] = field.default || {}
          }
        }
      }
    },
    toggleView (index) {
      this.view[index] = !this.view[index]
      this.$forceUpdate()
    },
    setComponent (component, target, index) {
      target[index] = component
      this.$forceUpdate()
    },
    objectAsString (obj) {
      return jsBeautify(JSON.stringify(obj), { indent_size: 2 })
    },
    setObjectFromString (field, value) {
      try {
        this.component[field] = JSON.parse(value)
      } catch (e) {}
    },
    addPropToObject (component, field) {
      if (typeof component[field.name] === 'undefined') {
        component[field.name] = field.default || {}
      }

      component[field.name][''] = ''
      this.$forceUpdate()
    },
    removePropFromObject (object, key) {
      delete object[key]
      this.$forceUpdate()
    },
    editKey: debounce(function (object, oldKey, newKey) {
      const value = object[oldKey]
      delete object[oldKey]
      object[newKey] = value
      this.$forceUpdate()
    }, 300)
  }
}
</script>

<style scoped>
  textarea.resize {
    resize: both !important;
  }
  .text-transform-initial {
    text-transform: initial;
  }
  .input-group .CodeMirror {
    height: 100px !important;
  }
</style>
